const consoleTransportBuilder = require('./consoleTransportBuilder');
const requestLoggerFactory = require('./requestLogger');

const logFormat = process.env.LOG_FORMAT;
const logLevel = process.env.LOG_LEVEL;
const logApplication = process.env.LOG_APPLICATION;
const consoleTransport = consoleTransportBuilder(logFormat, logLevel, logApplication);

const consoleLoggerFactory = require('./logger');

const logger = consoleLoggerFactory(logLevel, [consoleTransport]);
const requestLogger = requestLoggerFactory(logger);


module.exports = { logger, requestLogger };
